import React , {useState, useEffect} from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import ProductPopup from '../../components/popup/ProductPopup'
import SolutionPopup from '../../components/popup/SolutionPopup'

import usePageSEO from '../../hooks/usePageSEO'
import axios from "axios";
import Loader from '../../components/Loader'
import Slider from 'react-slick';
import { useParams, useLocation } from 'react-router-dom';

const Section = () => {

  const { slug } = useParams(); 
  const location = useLocation();
  const [currentId, setCurrentId] = useState(slug);

  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL; 

  const [openProduct, setOpenProduct] = useState(false);
  const [openSolution, setOpenSolution] = useState(false);
  const [enquiry, setEnquiry] = useState('');

  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')  
  const [solution, setSolution] = useState([]);


  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],          
  };

  const callEnquiry = (txt) =>{
    setEnquiry(txt);
    if(txt === 'Service Enquiry'){
        setOpenProduct(true);
        setOpenSolution(false);
    }else{
        setOpenProduct(false);
        setOpenSolution(true);
    }
  }  

  {/*
  const fetchInfo = () => {
    return axios.get(apiBaseUrl+`solution/section/${slug}`).then((res) => {
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setSolution(res.data.allsolutions)
    });
  };

  useEffect1(() => {
    setLoading(true);
    setTimeout(() => {
      setCurrentId(slug)
      fetchInfo()
      setLoading(false);
    }, 2000);
  }, [slug]);
*/}

  useEffect(() => {
    const fetchData = async () => {
        const res = await axios.get(apiBaseUrl + `solution/section/${slug}`)
        setMetaTitle(res.data.page.meta_title)
        setMetaDescription(res.data.page.meta_description)
        setSolution(res.data.allsolutions)
        setLoading(false)
    };
    if (slug) {
        fetchData();

    } else {
        setSolution([]); // Clear results if there's no query
    }
  }, [slug, location]);


  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  }) 

  return (
    <>
    <Header/>
    { loading && ( <Loader /> )}
    <div key={location.key}>
        {solution.map((item, index)=> {
            return(
            <div key={index}>
                <div id={item?.hash_link} className="container vertiocal-gap-1001"><hr /></div>
                <section className="section-content-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">                       
                                <div className="about-us-intro">
                                    <p className="blue">{item?.name}</p>
                                    <h2 className="heading col-lg-10 pl-0">{item?.heading}</h2>
                                    <p className='col-sm-12 pl-0'>{item?.description}</p>                            
                                    <button 
                                        className="btn btn-button margin-top-60" 
                                        onClick={() => callEnquiry(`${item?.call_enquiry}`)}>Enquire now
                                    </button>                          
                                </div>                            
                            </div> 
                            <div className="col-lg-6 col-md-6 col-sm-12 text-right">
                                <img src={`${siteUrl}${item?.image}`} className='fullwidth' alt={item?.name} />               
                            </div>
                        </div>
                    </div> 
                </section>
            {(item?.solution_project.length > 0) && (
                <section className="section-content-block bg-gray">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 ">                       
                                <div className="about-us-intro">
                                    <p className="our-experience">{item?.feature_heading}</p>
                                    <p>{item?.feature_content}</p>
                                </div>                            
                            </div>
                        </div>
                        <div className="row pb-100 ">
                            <div className="one-carousel col-sm-12 owl-carousel1">

                                <Slider {...settings}>
                                {item?.solution_project.map((item1, index1) => {
                                    return (                                       
                                    <div className="" key={index1}>                       
                                        <div className="Products projects">
                                            <img src={`${siteUrl}${item1?.image}`} alt={item1?.name} /> 
                                            <div className="project-des">
                                                <h4 className="heading">{item1?.name}</h4>
                                                <h5>{item1?.location}</h5>
                                                <p>{item1?.description}</p>
                                            </div>	
                                        </div>                            
                                    </div>
                                    );
                                })}                                
                                
                                </Slider>                            
                            </div>
                        </div>
                    </div>
                </section>
            )}

            </div>
            )
        })}
    </div>

    {openProduct ? <ProductPopup prm={enquiry} closePopup={() => setOpenProduct(false)} /> : null}
    {openSolution ? <SolutionPopup prm={enquiry} closePopup={() => setOpenSolution(false)} /> : null}	


    <Footer/>
    </>
  )
}

export default Section